import React, { useContext } from "react";
import Paper from '@mui/material/Paper';
import TopPanel from "../../Components/TopPanel";
import { LabTestContext } from "../context";
import { MuiButon } from "../../../../CommonComponents/MuiButton";

export default function LabTestHeader({
  _loadingSaveData,
  _saveLabTest,
}) {
  const {
    _labTestData,
    operation,
    setOperation,
    setLabTestId,
    _setLabTestData,
  } = useContext(LabTestContext);

  const handleSave = () => {
    _saveLabTest(
      { data: _labTestData },
      ({ data: NewLabTestData, success: callStatus }) => {
        //After successfull creation set the operation to change

        if (callStatus) {
          if (operation === "Create") {
          }
          setOperation("Change");
        }
        _setLabTestData(NewLabTestData);
        setLabTestId(NewLabTestData.id);
      }
    );
  };

  return (
    <Paper className="py-2 px-2 d-flex align-items-center justify-space-between customPaper">
      <TopPanel />
      <MuiButon
        title="Save"
        loading={_loadingSaveData}
        onClick={handleSave}
        disabled={operation === "Display"}
      />
    </Paper>
  );
}
